import { createSelector } from 'reselect';

const teamManagementState = (store) => store.apps.teamManagement;
const userStore = (store) => store.user;
const routerMatch = (_store, ownProps) => ownProps.match;

const containerSelector = createSelector(
  [teamManagementState, userStore, routerMatch],
  (teamManagement, user, match) => ({
    activity: teamManagement.groupDetails.get('activity'),
    group: teamManagement.groupDetails.get('group'),
    groupId: match.params.groupId,
    isOrgAdmin: user.isOrgAdmin(),
    loading: teamManagement.groupDetails.get('loading'),
    organizationSettings: teamManagement.organization.get('settings'),
  }),
);

const groupTeamsSelector = createSelector(
  [teamManagementState, routerMatch],
  (teamManagement, match) => ({
    group: teamManagement.groupDetails.get('group'),
    groupId: match.params.groupId,
    organizationSettings: teamManagement.organization.get('settings'),
    selectedTeams: teamManagement.groupDetails.get('selectedTeams'),
    teams: teamManagement.groupDetails.get('teams'),
  }),
);

const groupMembersSelector = createSelector(
  [teamManagementState],
  (teamManagement) => ({
    group: teamManagement.groupDetails.get('group'),
    selectedUsers: teamManagement.groupDetails.get('selectedUsers'),
    userTableLoading: teamManagement.groupDetails.get('userTableLoading'),
    users: teamManagement.groupDetails.get('users'),
  }),
);

const groupsEnabledSelector = createSelector(
  teamManagementState,
  ({ organization }) => {
    const groupsEnabled = organization.getIn(['settings', 'groups_enabled']);

    if ([true, false].includes(groupsEnabled)) {
      return { groupsEnabled, loading: false };
    }

    return { loading: true };
  },
);

export const teamsSelector = createSelector(
  teamManagementState,
  (filteredState) => ({ teams: filteredState.groupDetails.get('teams') }),
);

export default containerSelector;
export {
  containerSelector,
  groupsEnabledSelector,
  groupMembersSelector,
  groupTeamsSelector,
  routerMatch,
  teamManagementState,
};
